import { render, staticRenderFns } from "./Directions.vue?vue&type=template&id=70c867c8&"
import script from "./Directions.vue?vue&type=script&lang=js&"
export * from "./Directions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports